import store from '../store';

export default class Data {

  constructor(api) {
    this.api = api
  }

  _array(list) {
    return list && Array.isArray(list) ? list : [list]
  }

  init() {
    return this.api.call_init({
      '_class': 'Data',
      '_method': 'init'
    }).then(data => {
      this._init(data)
      store.commit('decInit')
    }, err => {
      store.commit('decInit')
      throw err
    })
  }

  reInit() {
    return this.api.call_busy({
      '_class': 'Data',
      '_method': 'init'
    }).then(data => {
      this._init(data, false)
    })
  }

  useraccounts() {
    return this.api.call_busy({
      '_class': 'Data',
      '_method': 'useraccounts'
    }).then(response => {
      // TODO: validation
      let accounts = response
      accounts = accounts.user
      ? (
        accounts.user.length
        ? accounts.user.map(a => a._attributes)
        : [accounts.user._attributes]
      )
      : []
      store.commit('setAccounts', accounts)
    })
  }

  // --- helpers

  _init(data, setLang=true) {
    // TODO: validation
    // TODO: transform data
    store.commit('setRawData', data)

    const user = store.getters.user
    user.id = data.session.user.id._text
    user.fullname = data.session.user.name._text
    user.name = data.session.user.account._text
    user.email = data.session.user.email._text
    user.is_admin = (data.session.user.is_admin._text == 1)
    store.commit('setUser', user)

    // fixed fields are setup at App.vue

    // parse Data Categories
    data.category_lists = this._array(data.category_lists.category_list)
    if (data.category_lists.length) {
      const categories = data.category_lists.filter(a => a.category && (a.category.length || !Array.isArray(a.category)))
        .map(a => {
          return {
            id: a._attributes.id, //
            value: a._attributes.id, //
            name: a._attributes.name, //
            // type //
            multiple: a._attributes.multiple || false,
            // multiple: '1', // all categories are forced to be "multiple" (to resemble the FLASH behavior)
            // children: (Array.isArray(a.category) ? a.category : [a.category])
            children: this._array(a.category)
              .map(a => {
                const cat = {
                  id: a._attributes.id, name: (a._text? a._text.trim() : ('[Undefined categoty name with ID]:' + a._attributes.id))
                }
                if (a._attributes.desc) {
                  cat.desc = a._attributes.desc.trim()
                }
                return cat
              })
              .sort((a, b) => {
                return a.name.localeCompare(b.name)
              }),
            label: a._attributes.name, // +
            text: a._attributes.name, // +
            datatype: 'catlist', // +
            type: 'catlist', // +
          }
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      if (categories.length) {
        const catDict = {}
        for (let categ of categories) {
          // console.log('cat.id: ', categ.id)
          for (let child of categ.children) {
            // console.log('---> id: ', dd)
            catDict[child.id] = child.desc? { catId: categ.id, name: child.name, desc: child.desc } : { catId: categ.id, name: child.name }
          }
        }
        store.commit('setCategoryDict', catDict)
        store.commit('setDataCategories', categories)
      }
    }

    // parse Data FreeFields
    data.freefields = data.freefields && data.freefields.freefield ? (data.freefields.freefield.length ? data.freefields.freefield : [data.freefields.freefield]) : []
    if (data.freefields && data.freefields.length) {
      const customFields = data.freefields.map(a => {
          return {
            id: a._attributes.id, // xml
            value: a._attributes.id, // xml
            name: a._text, // xml
            type: 'free', // xml
            init_type: a._attributes.type,
            label: a._text, // +
            text: a._text, // +
            datatype: a._attributes.type ? 'free' : a._attributes.type, // + //// ??
            field: `FF_${a._attributes.id}`,
            desc: a._attributes.desc ? a._attributes.desc : '',
          }
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      if (customFields.length) {
        store.commit('setDataCustomFields', customFields)
      }
    }

    // parse/set Data Additional Fields
    const additionalFields = require('../config/additional_fields.json')
    store.commit('setDataAdditionalFields', additionalFields)

    // parse Data Countries
    data.countries = data.countries && data.countries.country ? (data.countries.country.length ? data.countries.country : [data.countries.country]) : []
    if (data.countries && data.countries.length) {
      const countries = data.countries.map(a => {
          return {
            id: a._attributes.iso_code,
            value: a._attributes.iso_code,
            iso_code: a._attributes.iso_code,
            name: a._attributes.name,
            label: a._attributes.name,
            text: a._attributes.name
          }
        })
        .sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
      if (countries.length) {
        store.commit('setDataCountries', countries)
      }
    }

    // parse Data Languages
    data.languages = data.languages && data.languages.language ? (data.languages.language.length ? data.languages.language : [data.languages.language]) : []
    if (data.languages && data.languages.length) {
      const languages = data.languages.map(a => {
          return {
            id: a._attributes.id,
            value: a._attributes.id,
            locale_lang: a._attributes.locale_lang,
            name: a._attributes.name,
            label: a._attributes.name,
            text: a._attributes.name,
            locale: a._attributes.locale,
          }
        })
        // prevent collecting new languages on re-init (reload UI forms infinitely)
      if (languages.length && setLang) {
        store.commit('setDataLanguages', languages)
      }
    }

    if (data.nl_base_link && data.nl_base_link._text) {
      store.commit('setDataNlBaseLink', data.nl_base_link._text)
    }

  }
}
